import { H5 } from 'UIComponents/elements/headings';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import ApprovalHeadingI18n from '../i18n/ApprovalHeadingI18n';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApprovalHeading() {
  const {
    noApprovalData
  } = useApprovalConditions();
  if (noApprovalData) {
    return null;
  }
  return /*#__PURE__*/_jsx(H5, {
    className: "m-bottom-0",
    "data-test-id": "approval-heading",
    children: /*#__PURE__*/_jsx(ApprovalHeadingI18n, {})
  });
}
export default ApprovalHeading;